import ModelService from '../base/ModelService';

class User extends ModelService {
  constructor() {
    super('users');
  }
}

export default new User();
